<template>
  <div class="area background">
    <div class="text">
      <div class="container">
        <div class="center">
          <div v-if="status === 'select'">
            <h2>Upload your ultrasound data</h2>
            <h3>
              Select and
              <span @mouseover="showInfo = true" @mouseleave="showInfo = false"
                >upload<span class="star">*</span></span
              >
              your ultrasound video files in which you want to track the
              muscle-tendon junction.
            </h3>
            <h3>The data set and upload restrictions are as follows:</h3>
            <ul>
              <li>Supported file formats: .avi, .mpeg, .mp4, .mov and .wmv</li>
              <li>Max. size of data set: 200MB</li>
              <li>Max. size per video: 100MB</li>
              <li>Max. number of videos: 10</li>
            </ul>
            <span v-if="status === 'select'" class="upload">
              <form action="/" method="POST" enctype="multipart/form-data">
                <input
                  id="select_files"
                  type="file"
                  accept="video/*"
                  ref="files"
                  multiple
                  v-on:change="callHandleFiles($event)"
                  class="custom-file-input"
                />
                <input
                  id="select_folder"
                  type="file"
                  accept="video/*"
                  name="files"
                  webkitdirectory
                  multiple
                  v-on:change="callHandleFiles($event)"
                  class="custom-folder-input"
                />
              </form>
            </span>
            <div>
              <span v-if="showInfo === true" class="info">
                <span class="star">*</span>Data will not be stored on cloud
                servers beyond the requested predictions. During processing data
                stays accessible for you via your private and secret key. If
                connection is lost or in any other unforeseen event, your data
                will be deleted from the servers.
              </span>
            </div>
          </div>
          <div v-if="status !== 'select'">
            <h2>Uploading data...</h2>
            <div class="status" v-if="status === 'select'"></div>
            <div class="status" v-if="status === 'error'">
              <badge type="danger">{{ errorMessage }}</badge>
            </div>
            <div class="status" v-if="status === 'duplicate'">
              <badge type="default"
                >Selected Files have already been uploaded</badge
              >
            </div>
            <div class="status" v-if="status === 'finished'">
              <badge type="success">upload finished!</badge>
            </div>
            <ul id="example-1" class="ul-bar">
              <li v-for="video in videos" :key="video.id" class="li-bar">
                <div v-if="status === 'uploading'">{{ video.name }}</div>
                <a v-bind:href="video.url" v-if="status !== 'uploading'">{{
                  video.name
                }}</a>
                <button
                  v-if="status !== 'uploading'"
                  @click="deleteVideo(video.name)"
                  class="trash"
                >
                  <img
                    src="../../assets/img/trash.jpg"
                    class="trash-icon"
                    alt=""
                  />
                </button>
                <md-progress-bar
                  class="md-custom bar"
                  :md-value="parseInt(video.uploadProgress)"
                ></md-progress-bar>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { Badge } from "@/components";

export default {
  name: "UploadField",
  props: ["userID", "videos", "uploadParams"],
  data() {
    return {
      maxFileSize: 100e6,
      maxUploadSize: 200e6,
      maxVideoCount: 10,
      currentlyUploading: 0,
      message: "",
      errorMessage: "",
      status: "select",
      showInfo: false
    };
  },
  components: {
    Badge
  },
  methods: {
    report_upload() {
      this.$gtag.event("upload_video", { method: "Google" });
    },
    async callHandleFiles(event) {
      const files = event.target.files;
      if (this.checkFileSize(files)) {
        let uploadList = this.createUploadList(files);
        if (uploadList === false) {
          this.status = "error";
        } else if (uploadList.length > 0) {
          this.status = "uploading";
          await this.handleFiles(files, uploadList, this.userID);
          await this.getVideoURLs();
        } else {
          this.status = "duplicate";
        }
      }
    },
    checkFileSize(files) {
      for (let file of files) {
        if (file.size >= this.maxFileSize) {
          this.status = "error";
          this.errorMessage = `Video ${
            file.length
          } exceeds maximum file size of ${this.maxFileSize / 1000000} MB`;
          return false;
        }
      }
      return true;
    },
    createUploadList(files) {
      let additionalUploadSize = 0;
      let additionalVideoCount = 0;
      let uploadList = [];
      let displayMessage = true;
      for (let i = 0; i < files.length; i++) {
        let alreadyUploaded = false;
        for (let video of this.videos) {
          if (files[i].name === video.name) {
            alreadyUploaded = true;
            break;
          }
        }
        if (!alreadyUploaded && !this.isHiddenFile(files[i].name)) {
          if (
            this.uploadParams.videoCount + additionalVideoCount + 1 >
            this.maxVideoCount
          ) {
            this.errorMessage = `Video count exceeds limit of ${this.maxVideoCount} Videos`;
            return false;
          }
          if (
            this.uploadParams.totalUploadSize +
              additionalUploadSize +
              files[i].size >=
            this.maxUploadSize
          ) {
            this.errorMessage = `Upload exceeds size limit of ${this
              .maxUploadSize / 1000000} MB`;
            return false;
          }
          additionalUploadSize += files[i].size;
          additionalVideoCount += 1;
          uploadList.push(i);
          this.$emit("updateButton", false);
          if (displayMessage) {
            this.message = "upload started...";
            this.$emit("updateButton", false);
            displayMessage = false;
          }
        }
      }
      this.uploadParams.videoCount += additionalVideoCount;
      this.uploadParams.totalUploadSize += additionalUploadSize;
      return uploadList;
    },
    isHiddenFile(name) {
      return name[0] === ".";
    },
    handleFiles(files, uploadList, user_ID) {
      return new Promise(resolve => {
        let num_files = uploadList.length;
        for (let i = 0; i < uploadList.length; i++) {
          let file = files[uploadList[i]];
          let filename = file.name;
          let size = file.size;
          $.getJSON(
            "/get_upload_url",
            {
              user_ID: user_ID,
              filename: filename,
              content_type: file.type
            },
            this.uploadCallback(i, file, filename, num_files, size, resolve)
          );
        }
      });
    },
    uploadCallback(i, uploadedFile, filename, num_files, size, resolve) {
      return data => {
        let url = data["url"];
        let key = data["key"];
        this.currentlyUploading += 1;
        this.report_upload();
        this.upload(
          i,
          url,
          uploadedFile,
          key,
          filename,
          num_files,
          size,
          resolve
        );
      };
    },
    upload(i, url, file, key, filename, num_files, size, resolve) {
      $.ajax({
        xhr: () => {
          this.videos.push({
            id: this.uploadParams.totalUploadCount,
            name: filename,
            size: size,
            url: "",
            uploadProgress: 0,
            prediction: {}
          });
          let xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener(
            "progress",
            event => {
              if (event.lengthComputable) {
                let percentComplete = (event.loaded / event.total) * 100;
                let idx = this.videos.findIndex(p => p.name === filename);
                this.videos[idx].uploadProgress = percentComplete;
              }
            },
            false
          );
          this.uploadParams.totalUploadCount += 1;
          return xhr;
        },
        url: url,
        type: "PUT",
        data: file,
        contentType: file.type,
        success: () => {
          this.currentlyUploading -= 1;
          if (this.currentlyUploading <= 0) {
            this.$emit("increaseCurrentStep");
            this.status = "finished";
            resolve();
          }
        },
        error: result => {},
        processData: false
      });
    },
    getVideoURLs() {
      return new Promise(resolve => {
        for (let i = 0; i < this.videos.length; i++) {
          $.get(
            "/get_video_url",
            {
              user_ID: this.userID,
              filename: this.videos[i].name
            },
            response => {
              this.videos[i].url = response;
              resolve();
            }
          );
        }
      });
    },
    async deleteVideo(videoName) {
      this.requestVideoDeletion(videoName);
      this.uploadParams.videoCount -= 1;
      let videosTemp = [];
      for (let i = 0; i < this.videos.length; i++) {
        if (this.videos[i].name !== videoName) {
          videosTemp.push(this.videos[i]);
        }
      }
      this.$emit("updateVideos", videosTemp);
      let found = this.videos.find(e => e.name === videoName);
      let size = found.size;
      this.uploadParams.totalUploadSize -= size;
      if (videosTemp.length <= 0) {
        this.$emit("updateButton", false);
      }
    },
    requestVideoDeletion(videoName) {
      return new Promise(resolve => {
        $.get(
          "/delete_video",
          {
            user_ID: this.userID,
            filename: videoName
          },
          response => {
            resolve();
          }
        );
      });
    }
  },
  created() {
    if (this.videos.length <= 0) {
      this.$emit("updateButton", false);
    }
  },
  destroyed() {}
};
</script>

<style scoped>
@import "../../assets/css/styling.css";

input[type="file"] {
  color: #fff;
}

.upload {
  display: inline-block;
  margin-top: 5vh;
}

.bar {
  min-width: 48vh;
  max-width: 44vw;
  margin-left: 2px;
}

.info {
  border-top: 40px;
}

div.center {
  padding-left: 0;
  padding-top: 40px;
}
.custom-file-input::-webkit-file-upload-button {
  visibility: hidden;
}
.custom-file-input::before {
  content: "Select files";
  display: inline-block;
  background: #2554c7;
  border: 0 solid #999;
  border-radius: 10px;
  margin-bottom: 25px;
  padding: 20px 20px;
  outline: none;
  -webkit-user-select: none;
  cursor: pointer;

  font-size: 24pt;
  font-family: Helvetica, serif;
  color: #fff;
}
.custom-file-input:hover::before {
  border-color: black;
}
.custom-file-input:active::before {
  background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
}
.custom-folder-input::-webkit-file-upload-button {
  visibility: hidden;
}
.custom-folder-input::before {
  content: "Select folder";
  display: inline-block;
  background: #2554c7;
  border: 0 solid #999;
  border-radius: 10px;
  padding: 20px 20px;
  outline: none;
  -webkit-user-select: none;
  cursor: pointer;
  font-size: 24pt;
  font-family: Helvetica, serif;
  color: #fff;
}
.custom-folder-input:hover::before {
  border-color: black;
}
.custom-folder-input:active::before {
  background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
}

.status {
  padding-top: 40px;
  padding-bottom: 40px;
}

.trash {
  width: 20px;
  border: 0;
  margin-left: 20px;
  background-color: #ffffff;
}

.trash-icon {
  padding-bottom: 5px;
  cursor: pointer;
}

.li-bar {
  list-style-type: None;
  margin-left: 0;
  padding: 0;
}

.ul-bar {
  padding: 0;
  margin-top: 40px;
}

ul {
  font-size: 15pt;
  list-style-type: square;
  padding-top: 0;
}

li {
}

a {
  color: black;
}
</style>
